export function loadFromStorage<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);

    if (!raw || raw === "[]" || raw === "") {
      return fallback;
    }

    const parsed = JSON.parse(raw);

    if (Array.isArray(fallback) && !Array.isArray(parsed)) {
      console.warn(`Valor inválido para ${key}, usando fallback`);
      return fallback;
    }

    return parsed as T;
  } catch (error) {
    console.error(`Erro ao parsear ${key} do localStorage:`, error);
    return fallback;
  }
}
